const DEFAULT_EVENT_VERSION = 1

function getVisitorId() {
  try {
    const url = new URL(window.location.href)
    const id = (url.searchParams.get('id') || '').trim()
    return id || 'anonymous'
  } catch (error) {
    console.warn('Failed to parse URL for visitor id:', error)
    return 'anonymous'
  }
}

function normalizeEndpoint(endpoint) {
  if (!endpoint) return ''
  return endpoint.trim().replace(/\/$/, '')
}

function getClickTargetInfo(target) {
  if (!target || !target.tagName) {
    return {
      tag: 'unknown',
      id: '',
      className: '',
      text: ''
    }
  }

  const text = (target.innerText || target.textContent || '').trim().slice(0, 120)

  return {
    tag: String(target.tagName || '').toLowerCase(),
    id: target.id || '',
    className: typeof target.className === 'string' ? target.className.slice(0, 200) : '',
    text
  }
}

function postTracking(endpoint, payload) {
  const body = JSON.stringify(payload)

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' })
    navigator.sendBeacon(endpoint, blob)
    return
  }

  fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true
  }).catch((error) => {
    console.warn('Tracking request failed:', error)
  })
}

function buildBasePayload(visitorId) {
  return {
    version: DEFAULT_EVENT_VERSION,
    visitorId,
    url: window.location.href,
    path: window.location.pathname,
    query: window.location.search,
    title: document.title,
    userAgent: navigator.userAgent,
    referrer: document.referrer,
    timestamp: new Date().toISOString()
  }
}

export function initTracking({ endpoint = '' } = {}) {
  const workerEndpoint = normalizeEndpoint(endpoint)
  if (!workerEndpoint) {
    console.info('Tracking disabled: VUE_APP_TRACKING_WORKER_URL is empty')
    return
  }

  const visitorId = getVisitorId()

  const sendEvent = (eventType, extra = {}) => {
    const payload = {
      ...buildBasePayload(visitorId),
      eventType,
      ...extra
    }
    postTracking(workerEndpoint, payload)
  }

  sendEvent('page_view')

  document.addEventListener('click', (event) => {
    const targetInfo = getClickTargetInfo(event.target)
    sendEvent('click', { target: targetInfo })
  }, { passive: true })
}
